import React from "react";
import { ShieldCheck, Key, ScrollText, Users } from "lucide-react";

const ROLES = [
  ["Super Admin", "Full system access, config, roles, audit."],
  ["Admin", "Manage modules, tenders, projects, users."],
  ["CEO", "Executive dashboards, approvals, portfolio review."],
  ["Director", "Programme oversight, works & finance sign-off."],
  ["Finance", "Budget, payments, GST, bank reconciliation."],
  ["HR",      "Employees, payroll, leave, recruitment."],
  ["Engineer", "Projects, milestones, quality inspection."],
  ["Inspector","Field inspections, geo-tagging, reports."],
  ["Citizen",  "Apply for schemes, track, grievance, RTI."],
];

const AUDIT = [
  ["2026-01-14 10:32", "admin@peda.gov.in", "USER_UPDATE", "Updated role of engineer@peda.gov.in"],
  ["2026-01-14 09:14", "director@peda.gov.in", "PROJECT_APPROVE", "Approved 50 MW Bathinda tender"],
  ["2026-01-13 17:45", "finance@peda.gov.in", "PAYMENT_RELEASE", "Released ₹42.5L to Bhullar Constructions"],
  ["2026-01-13 12:08", "system", "BACKUP", "Nightly database backup completed successfully"],
];

export default function SecurityPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Security & Governance</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Access Control & Audit</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="kpi-card">
          <div className="h-10 w-10 rounded-lg bg-emerald-500/10 text-emerald-500 grid place-items-center"><ShieldCheck className="h-5 w-5"/></div>
          <div className="mt-3 font-heading text-2xl font-bold">JWT + RBAC</div>
          <div className="text-xs text-muted-foreground">Access model</div>
        </div>
        <div className="kpi-card">
          <div className="h-10 w-10 rounded-lg bg-sky-500/10 text-sky-500 grid place-items-center"><Key className="h-5 w-5"/></div>
          <div className="mt-3 font-heading text-2xl font-bold">2FA</div>
          <div className="text-xs text-muted-foreground">Available for admins</div>
        </div>
        <div className="kpi-card">
          <div className="h-10 w-10 rounded-lg bg-amber-500/10 text-amber-500 grid place-items-center"><Users className="h-5 w-5"/></div>
          <div className="mt-3 font-heading text-2xl font-bold">{ROLES.length}</div>
          <div className="text-xs text-muted-foreground">Roles configured</div>
        </div>
        <div className="kpi-card">
          <div className="h-10 w-10 rounded-lg bg-fuchsia-500/10 text-fuchsia-500 grid place-items-center"><ScrollText className="h-5 w-5"/></div>
          <div className="mt-3 font-heading text-2xl font-bold">Daily</div>
          <div className="text-xs text-muted-foreground">Backup cadence</div>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold mb-3">Role Matrix</div>
          <table className="w-full">
            <thead><tr><th className="table-th">Role</th><th className="table-th">Capability</th></tr></thead>
            <tbody>
              {ROLES.map(([r, d]) => (
                <tr key={r} className="border-t border-border">
                  <td className="table-cell font-semibold">{r}</td>
                  <td className="table-cell text-muted-foreground">{d}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="font-heading font-semibold mb-3">Recent Audit Trail</div>
          <div className="space-y-2">
            {AUDIT.map(([ts, actor, action, desc], i) => (
              <div key={i} className="rounded-lg border border-border p-3">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{ts} · {actor}</div>
                <div className="mt-1 text-sm"><span className="font-semibold">{action}</span> — {desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
